import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  large?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  border-radius: 5px;
  border: 1px solid #ced4da;
  background-color: #fff;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  padding: 7px 10px;
  ${props =>
    props.large &&
    css`
      padding: 12px 10px;
    `}

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: #ff9000;
      border-color: #ff9000;
    `}

  ${props =>
    props.isFilled &&
    css`
      color: #ff9000;
    `}

  textarea {
    flex: 1;
    border: 0;
    text-transform: uppercase;

    &::placeholder {
      color: #a8a8b3;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 12px;
  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
